import api from "../api/axios";

async function getPermissions() {
  const response = await api.get(`/api/v1/permissions`);
  if (!response) {
    throw new Error(response.statusText);
  }

  return response;
}

async function getPermissionsByRoleId(roleId) {
  const response = await api.get(`api/v1/roles/${roleId}/permissions_for_role`);
  if (!response) {
    throw new Error(response.statusText);
  }

  return response;
}

async function updateRolePermissions(roleId, permissions) {
  
  const response = await api.post(`/api/v1/roles/${roleId}/permissions`, {
    permissions,
  });
  if (!response) {
    throw new Error(response.statusText);
  }

  return response;
}

export { getPermissions, getPermissionsByRoleId, updateRolePermissions };
